import React, { memo } from "react";
import { useDispatch } from "react-redux";

import galleryAdd from "../../../../image/assets/gallery-add.svg";
import closeSquare from "../../../../image/assets/close-square.svg";
import { fileApi } from "../../../../utility/api/apiList";

import { showDangerAlert } from "../../../../redux/actions/alert/alertActions";

import InputComponent from "../../form/input";

import {
  StyledImageSection,
  StyledUploadNewImage,
  StyledParagraph,
  UploadedImageWrapper,
} from "./styledLabReport";

const UploadImageSection = ({
  isLogin,
  updateData,
  uploaderImageArray,
  setUploaderImageArray,
  uploaderCounter,
  setUploaderCounter,
}) => {
  const dispatch = useDispatch();
  const filterImages = (imageId) => {
    const filteredImages = uploaderImageArray.filter(
      (item) => item.id !== imageId
    );
    setUploaderImageArray(filteredImages);
  };

  const handleUploadImage = (e) => {
    let imageSrc = e.target.files[0]
      ? URL.createObjectURL(e.target.files[0])
      : "";
    let maxSize = 1 * 1024 * 1024; //mega bytes
    if (e.target.files[0]) {
      if (e.target.files[0].size > maxSize) {
        dispatch(showDangerAlert("حداکثر حجم فایل باید 1 مگابایت باشد."));
        return;
      }
    } else {
      return;
    }
    let newElemment = {
      id: uploaderCounter,
      src: imageSrc,
      file: e.target.files[0],
    };
    if (imageSrc !== "") {
      setUploaderImageArray(() => [...uploaderImageArray, newElemment]);
      setUploaderCounter(uploaderCounter + 1);
    } else {
      return;
    }
  };

  const handleRemoveImage = (imageId) => {
    const findItem = uploaderImageArray.find((item) => item.id === imageId);
    if (findItem.is_uploaded_server) {
      updateData.deleteImage(null, null, `${fileApi}${imageId}/`).then(() => {
        updateData.simReportRun();
      });
    } else {
      filterImages(findItem.id);
    }
  };

  return (
    <section className="w-100 my-3 my-md-0 d-flex flex-column flex-md-row align-items-md-end">
      <StyledImageSection
        className="mt-4"
        $displayGrid={uploaderImageArray.length !== 0 && true}
      >
        {uploaderImageArray.length <= 3 && (
          <StyledUploadNewImage>
            <InputComponent
              id="new-image-input"
              title={
                <img
                  src={galleryAdd}
                  alt="gallery-add"
                  className="gallery-add"
                />
              }
              type="file"
              disabled={!isLogin}
              onChange={handleUploadImage}
              accept="image/png, image/jpeg,image/jpg"
              containerClass="border-0"
              className="invisible"
            />
          </StyledUploadNewImage>
        )}
        {uploaderImageArray.map((image) => (
          <UploadedImageWrapper key={image.id}>
            <img
              className="close-square"
              src={closeSquare}
              alt="close-square"
              onClick={() => handleRemoveImage(image.id)}
            />
            <img
              className="uploaded-image"
              src={image.src}
              alt="uploaded"
              width="100%"
              height="100%"
            />
          </UploadedImageWrapper>
        ))}
      </StyledImageSection>
      {uploaderImageArray.length === 0 && (
        <StyledParagraph className="mx-2 mb-0 mt-2 mt-md-0">
          حداکثر 4 تصویر می‌توانید بارگزاری کنید.
        </StyledParagraph>
      )}
    </section>
  );
};

export default UploadImageSection;
